<div id="showwarning" class="w3-modal w3-modal-theme">
  <div id="warning" class="w3-modal-content w3-padding w3-display-middle w3-center w3-border-theme w3-padding w3-animate-opacity w3-theme-l4 w3-topbar w3-bottombar w3-leftbar w3-rightbar">
    <p>{{ warning | translate: router.transparams }}</p>
    <p>{{ 'warnings.continue' | translate: router.transparams }}</p>
    <input
      type        = "button"
      class       = "w3-button w3-border w3-button-theme w3-margin-right pageButton w3-round"
      name        = "submit"
      value       = "{{ 'buttons.yes' | translate: router.transparams }}"
      title       = "{{ 'buttons.yes' | translate: router.transparams }}"
      (click)     = "action(true)"
    >
    <input
      type        = "button"
      class       = "w3-button w3-border w3-button-theme pageButton w3-round"
      name        = "cancel"
      value       = "{{ 'buttons.no' | translate: router.transparams }}"
      title       = "{{ 'buttons.no' | translate: router.transparams }}"
      (click)     = "cancel()"
    >
  </div>
</div>
<div *ngIf="initialized" class="w3-container w3-margin-top" [class]="router.back ? 'w3-animate-left' : 'w3-animate-right'">
  <omnipas-pageheader></omnipas-pageheader>
  <omnipas-cardpreview *ngIf="environment.getEnvValue('cardpreview') && !list.emptyList(this.router.persondata)"></omnipas-cardpreview>
  <div class="w3-margin">
    <div *ngIf="!list.emptyList(router.cardhist)">
      <ul >
         <li *ngFor="let ch of router.cardhist | keyvalue">{{ date.datetostring( ch.value['modifiedOn'], date.datetimeformat2 ) }} - {{ 'status.description.'+ch.value['statusId'] | translate: router.transparams | customInitCap }}
      </ul>
      <a class="link" (click)="showInfo()" title="{{ 'welcome.cardinfo' | translate: router.transparams }}">{{ 'welcome.cardinfo' | translate: router.transparams }}</a>
    </div>
    <p *ngIf="(!environment.getEnvValue('horizon')) && (!environment.getEnvValue('savephotoonserver')) && list.emptyList(router.cardhist)">
      <span>
        {{ 'status.description.'+list.getValue( this.router.persondata, 'cardStatus', true ) | translate: router.transparams | customInitCap }}
      </span>
      <a class="link" (click)="showInfo()" title="{{ 'welcome.cardinfo' | translate: router.transparams }}">{{ 'welcome.cardinfo' | translate: router.transparams }}</a>
    </p>
    <p *ngIf="router.transparams.customer_shortname == 'noorderpoort'" class="w3-border w3-padding w3-card">
      <span><b>{{ 'welcome.address' | translate: router.transparams | customInitCap }}</b></span>
      <br/>
      <span *ngIf="list.getValue( this.router.persondata, 'street',       true ) != ''">{{ list.getValue( this.router.persondata, 'street', true )}}&nbsp;</span>
      <span *ngIf="list.getValue( this.router.persondata, 'number',       true ) != ''">{{ list.getValue( this.router.persondata, 'number', true )}}</span>
      <span *ngIf="list.getValue( this.router.persondata, 'suffix',       true ) != ''">{{ list.getValue( this.router.persondata, 'suffix', true )}}</span>
      <br/>
      <span *ngIf="list.getValue( this.router.persondata, 'postalCode',   true ) != ''">{{ list.getValue( this.router.persondata, 'postalCode', true )}}&nbsp;</span>
      <span *ngIf="list.getValue( this.router.persondata, 'city',         true ) != ''">{{ list.getValue( this.router.persondata, 'city', true )}}</span>
      <br/>
      <br/>
      <span><b>{{ 'welcome.location' | translate: router.transparams | customInitCap }}</b></span>
      <br/>
      <span *ngIf="list.getValue( this.router.persondata, 'LocationName', true ) != ''">{{ list.getValue( this.router.persondata, 'LocationName', true )}}</span>
    </p>
    <p *ngIf="(!environment.getEnvValue('horizon')) && !environment.getEnvValue('savephotoonserver')">{{ 'welcome.help' | translate: router.transparams }}</p>
    <div *ngIf="(router.transparams.customer_shortname == 'Fontys' || router.transparams.customer_shortname == 'dev')">
      <p><br><b>{{ 'welcome.photocancelled' | translate: router.transparams }}</b></p>
      <p>
        <b>{{ 'welcome.newstudenttitle' | translate: router.transparams }}</b><br/>
        {{ 'welcome.newstudent' | translate: router.transparams }}
      </p>
      <p>
        <b>{{ 'welcome.newemployeetitle' | translate: router.transparams }}</b><br/>
        {{ 'welcome.newemployee' | translate: router.transparams }}
      </p>
      <p>
        <b>{{ 'welcome.replacementtitle' | translate: router.transparams }}</b><br/>
        {{ 'welcome.replacementtext' | translate: router.transparams }} <a class="link" href="{{ 'welcome.replacementurl' | translate: router.transparams }}" target="_blank">{{ 'welcome.replacementurlte' | translate: router.transparams }}</a>
        
      </p>
      <p>
        <b>{{ 'welcome.parkingtitle' | translate: router.transparams }} </b><br/>
        {{ 'welcome.parkingtext' | translate: router.transparams }} <a class="link" href="{{ 'welcome.parkingurl' | translate: router.transparams }}" target="_blank">{{ 'welcome.parkingurltext' | translate: router.transparams }} </a>
      </p>
    </div>
  </div>
  <div class="w3-margin" *ngIf="showFirstPhoto && !environment.getEnvValue('photoAgreedNotOnFirstPage')">
    <input
      id          = "agreed"
      name        = "agreed"
      type        = "checkbox"
      class       = "w3-check w3-check-theme w3-margin-right"
      title       = ""
      (click)     = "photo.togglePhotoAgreed()"
      [checked]   = "photo.photoAgreed ? 'checked' : ''"
      tabindex    = "1"
    >
    <label for = "agreed">{{ 'welcome.agreed' | translate: router.transparams }}</label>
    <p *ngIf="environment.getEnvValue('horizon')">
      <b>Belangrijk:</b><br/>
      Je ID kaart wordt ook gebruikt ter identificatie. Bij onduidelijke of ongepaste foto's is je ID kaart niet geldig.
    </p>
    <p *ngIf="environment.getEnvValue('horizon')">
      <b>Let op:</b><br/>
      Na jouw toestemming kunnen wij de pas printen. Wij gebruiken jouw foto alleen voor de genoemde doeleinden.
    </p>
  </div>
  <div *ngIf="router.transparams.customer_shortname == 'Inholland'" class="w3-margin">
    <p>{{ 'welcome.ienotsupported' | translate: router.transparams }}</p>
  </div>
  <div class="w3-margin" *ngIf="!showPhotoButtons">
    <p><b>{{ 'welcome.cardinprogress' | translate: router.transparams }}</b></p>
  </div>
  <div class="w3-margin" *ngIf="showPhotoUnapproved">
    <p><b>{{ 'welcome.photounapproved' | translate: router.transparams }}</b></p>
  </div>
  <div class="w3-margin" *ngIf="showPhotoDisapproved">
    <p><b>{{ 'welcome.photodisapproved' | translate: router.transparams }}</b></p>
  </div>
  <div class="w3-margin" *ngIf="showPhotoButtons && environment.getEnvValue('uploadphoto')">
    <p *ngIf="environment.getEnvValue('photorequirements')">
      <a class="link"
         title      = "{{ 'photorequirements.button' | translate: router.transparams }}"
         (click)    = "showPhotoRequirements()"
      >
        <i id = "icon-photorequirements" class= "w3-large fas fa-exclamation-circle"></i>&nbsp;{{ 'photorequirements.button' | translate: router.transparams }}
      </a>
    </p>
    <input
      id          = "photoUpload"
      name        = "photoUpload"
      type        = "button"
      class       = "w3-button w3-border w3-button-theme pageButton w3-round"
      value       = "{{ (showFirstPhoto ? 'welcome.upload.first' : 'welcome.upload.new') | translate: router.transparams }}"
      title       = "{{ (showFirstPhoto ? 'welcome.upload.first' : 'welcome.upload.new') | translate: router.transparams }}"
      (click)     = "action(false, 'upload')"
      [disabled]  = "showFirstPhoto == photo.photoAgreed || environment.getEnvValue('photoAgreedNotOnFirstPage') ? '' : 'disabled'"
      tabindex    = "2"
    >
  </div>
  <div class="w3-margin" *ngIf="showPhotoButtons && environment.getEnvValue('webcam') && !iOS()">
    <input
      id          = "Webcam"
      name        = "Webcam"
      type        = "button"
      class       = "w3-button w3-border w3-button-theme pageButton w3-round"
      value       = "{{ (showFirstPhoto ? 'welcome.webcam.first' : 'welcome.webcam.new') | translate: router.transparams }}"
      title       = "{{ (showFirstPhoto ? 'welcome.webcam.first' : 'welcome.webcam.new') | translate: router.transparams }}"
      (click)     = "action(false, 'webcam')"
      [disabled]  = "showFirstPhoto == photo.photoAgreed || environment.getEnvValue('photoAgreedNotOnFirstPage') ? '' : 'disabled'"
      tabindex    = "3"
    >
  </div>
  <div class="w3-margin" *ngIf="showChangeAddress && environment.getEnvValue('deliveryaddress')">
    <input
      id          = "ChangeDeliveryAddress"
      name        = "ChangeDeliveryAddress"
      type        = "button"
      class       = "w3-button w3-border w3-button-theme pageButton w3-round"
      value       = "{{ 'welcome.changedeliveryaddress' | translate: router.transparams }}"
      title       = "{{ 'welcome.changedeliveryaddress' | translate: router.transparams }}"
      (click)     = "changeDeliveryAddress()"
     >
  </div>
  <div class="w3-margin" *ngIf="showCardActivate && environment.getEnvValue('cardactivate')">
    <input
      id          = "ActivateCard"
      name        = "ActivateCard"
      type        = "button"
      class       = "w3-button w3-border w3-button-theme pageButton w3-round"
      value       = "{{ 'welcome.activatecard' | translate: router.transparams }}"
      title       = "{{ 'welcome.activatecard' | translate: router.transparams }}"
      (click)     = "activateCard()"
      tabindex    = "6"
    >
  </div>
  <div class="w3-margin" *ngIf="showCardBlock && environment.getEnvValue('cardblock')">
    <input
      id          = "BlockCard"
      name        = "BlockCard"
      type        = "button"
      class       = "w3-button w3-border w3-button-theme pageButton w3-round"
      value       = "{{ 'welcome.blockcard' | translate: router.transparams }}"
      title       = "{{ 'welcome.blockcard' | translate: router.transparams }}"
      (click)     = "blockCard()"
      tabindex    = "7"

    >
  </div>
  <div class="w3-margin" *ngIf="showCardDeblock && environment.getEnvValue('carddeblock')">
    <input
      id          = "DeblockCard"
      name        = "DeblockCard"
      type        = "button"
      class       = "w3-button w3-border w3-button-theme pageButton w3-round"
      value       = "{{ 'welcome.deblockcard' | translate: router.transparams }}"
      title       = "{{ 'welcome.deblockcard' | translate: router.transparams }}"
      (click)     = "deblockCard()"
      tabindex    = "8"

    >
  </div>
  <div class="w3-margin" *ngIf="showCardRequest && environment.getEnvValue('cardrequest')">
    <input
      id          = "CardRequest"
      name        = "CardRequest"
      type        = "button"
      class       = "w3-button w3-border w3-button-theme pageButton w3-round"
      value       = "{{ 'welcome.requestcard' | translate: router.transparams }}"
      title       = "{{ 'welcome.requestcard' | translate: router.transparams }}"
      (click)     = "requestCard()"
      tabindex    = "9"

    >
  </div>
  <div class="w3-margin" *ngIf="environment.getEnvValue('digitalcard') && this.list.getValue( this.router.persondata, 'cardStatus', true ) == '5'">
    <input
      id          = "DigitalCard"
      name        = "DigitalCard"
      type        = "button"
      class       = "w3-button w3-border w3-button-theme pageButton w3-round"
      value       = "{{ 'welcome.digitalcard' | translate: router.transparams }}"
      title       = "{{ 'welcome.digitalcard' | translate: router.transparams }}"
      (click)     = "digitalCard()"
      tabindex    = "10"
    >
  </div>
  <div class="w3-margin" *ngIf="environment.getEnvValue('nameoncard')">
    <input
      id          = "NameOnCard"
      name        = "NameOnCard"
      type        = "button"
      class       = "w3-button w3-border w3-button-theme pageButton w3-round"
      value       = "{{ 'welcome.nameoncard' | translate: router.transparams }}"
      title       = "{{ 'welcome.nameoncard' | translate: router.transparams }}"
      (click)     = "nameOnCard()"
      tabindex    = "10"
    >
  </div>
  <div class="w3-margin" *ngIf="environment.getEnvValue('changepublishpermission')">
    <input
      id          = "PublishPermission"
      name        = "PublishPermission"
      type        = "button"
      class       = "w3-button w3-border w3-button-theme pageButton w3-round"
      value       = "{{ 'welcome.photopermissions' | translate: router.transparams }}"
      title       = "{{ 'welcome.photopermissions' | translate: router.transparams }}"
      (click)     = "photopermissions()"
      tabindex    = "10"
    >
  </div>
  <div class="w3-margin" *ngIf="environment.getEnvValue('licenseplate')">
    <input
      id          = "LicensePlate"
      name        = "LicensePlate"
      type        = "button"
      class       = "w3-button w3-border w3-button-theme pageButton w3-round"
      value       = "{{ 'welcome.licenseplate' | translate: router.transparams }}"
      title       = "{{ 'welcome.licenseplate' | translate: router.transparams }}"
      (click)     = "licensePlate()"
      tabindex    = "10"
    >
  </div>
  <div class="w3-margin" *ngIf="environment.getEnvValue('chargingcard')">
    <input
      id          = "ChargingCard"
      name        = "ChargingCard"
      type        = "button"
      class       = "w3-button w3-border w3-button-theme pageButton w3-round"
      value       = "{{ 'welcome.chargingcard' | translate: router.transparams }}"
      title       = "{{ 'welcome.chargingcard' | translate: router.transparams }}"
      (click)     = "chargingcard()"
      tabindex    = "11"
    >
  </div>
  <div class="w3-margin" *ngIf="environment.getEnvValue('logoutbutton')">
    <input
      id          = "Logout"
      name        = "Logout"
      type        = "button"
      class       = "w3-button w3-border w3-button-theme pageButton w3-round"
      value       = "{{ 'header.logout' | translate: router.transparams }}"
      title       = "{{ 'header.logout' | translate: router.transparams }}"
      (click)     = "logout()"
      tabindex    = "12"
    >
  </div>
  <div *ngIf="router.transparams.customer_shortname == 'Inholland'" class="w3-margin">
    <p *ngIf="list.getValue( this.router.persondata, 'cardholderProfile', true ) == 'student'">
      <b>{{ 'welcome.student_help_b' | translate: router.transparams }}</b><br/>
      <span>{{ 'welcome.student_help_t' | translate: router.transparams }} <a href="mailto:csa&#64;inholland.nl">csa&#64;inholland.nl</a></span>
    </p>
    <p *ngIf="list.getValue( this.router.persondata, 'cardholderProfile', true ) != 'student'">
      <b>{{ 'welcome.employee_help_b' | translate: router.transparams }}</b><br/>
      <span>{{ 'welcome.employee_help_t' | translate: router.transparams }} <b>servicepunt.</b>{{ 'welcome.employee_help_e' | translate: router.transparams }}<b>.inholland.nl</b></span>
    </p>
  </div>
</div>
